export default __webpack_public_path__ + "static/img_product_orc-344744aea8e014bca599290ad682af94.png";